const invertedMessages = {
  'Certification List': 'certs.list.main.landmark',
};

export default invertedMessages;
